export default __webpack_public_path__ + "static/media/3.ba98a1ec.jpg";